import '../newstyle/css/author_freely.scss'
import '../newstyle/images/authorfreely_primarylogo.png'
import '../newstyle/images/logo-authorfreely-mobile.png'
